import React from "react";
import { StyledDescription } from "./index.styled";

type AppDescriptionProps = {
  children: React.ReactNode;
  [x: string]: any;
};

const AppTagStatus: React.FC<AppDescriptionProps> = ({ children, ...rest }: AppDescriptionProps) => (
  <StyledDescription {...rest}>
    {children}
  </StyledDescription>
);
export default AppTagStatus;
